import { initializeApp } from 'firebase/app'
import { getMessaging, isSupported } from 'firebase/messaging'

var vueAppFirebaseMessagingSenderTo =
    document
        .getElementById('app')
        .getAttribute('vueappfirebasemessagingsenderto') ||
    process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID
var vueAppFirebaseApiKey =
    document.getElementById('app').getAttribute('vueappfirebaseapikey') ||
    process.env.VUE_APP_FIREBASE_API_KEY
var vueAppFirebaseAuthDomain =
    document.getElementById('app').getAttribute('vueappfirebaseauthdomain') ||
    process.env.VUE_APP_FIREBASE_AUTH_DOMAIN
var vueAppFirebaseProjectId =
    document.getElementById('app').getAttribute('vueappfirebaseprojectid') ||
    process.env.VUE_APP_FIREBASE_PROJECT_ID
var vueAppFirebaseStorageBucket =
    document
        .getElementById('app')
        .getAttribute('vueappfirebasestorageBucket') ||
    process.env.VUE_APP_FIREBASE_STORAGE_BUCKET
var vueAppFirebaseAppId =
    document.getElementById('app').getAttribute('vueappfirebaseappid') ||
    process.env.VUE_APP_FIREBASE_APP_ID

const firebaseConfig = {
    apiKey: vueAppFirebaseApiKey,
    authDomain: vueAppFirebaseAuthDomain,
    projectId: vueAppFirebaseProjectId,
    storageBucket: vueAppFirebaseStorageBucket,
    messagingSenderId: vueAppFirebaseMessagingSenderTo,
    appId: vueAppFirebaseAppId
}
initializeApp(firebaseConfig)

export default { getMessaging, isSupported }
